import { render, staticRenderFns } from "./Multiproduct.vue?vue&type=template&id=0d5f5be7&scoped=true&"
import script from "./Multiproduct.vue?vue&type=script&lang=js&"
export * from "./Multiproduct.vue?vue&type=script&lang=js&"
import style0 from "./Multiproduct.vue?vue&type=style&index=0&id=0d5f5be7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5f5be7",
  null
  
)

export default component.exports